module.exports = __webpack_public_path__ + "static/img/ddf0dd63e83b929bfae930dd26e2cadb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_disable_03.png
// module id = OFrx
// module chunks = 1